'use client';

import React from 'react';
import { useUser, useClerk } from '@/components/provider/AuthProvider';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { UserIcon, ArrowRightOnRectangleIcon } from '@heroicons/react/24/outline';
import Link from 'next/link';

export function UserAvatar() {
	const { user, isSignedIn } = useUser();
	const { signOut } = useClerk();

	if (!isSignedIn || !user) {
		return null;
	}

	const initials = (user.fullName || user.email || 'U')
		.split(' ')
		.map((n) => n[0])
		.join('')
		.substring(0, 2)
		.toUpperCase();

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<button className="outline-none ring-offset-background transition-opacity hover:opacity-80 rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2">
					<Avatar className="h-9 w-9 border border-slate-200 shadow-sm">
						{user.imageUrl && <AvatarImage src={user.imageUrl} alt={user.fullName || 'User'} />}
						<AvatarFallback className="bg-primary/10 text-primary font-semibold text-xs">
							{initials}
						</AvatarFallback>
					</Avatar>
				</button>
			</DropdownMenuTrigger>
			<DropdownMenuContent align="end" className="w-56 mt-1 p-1">
				<div className="flex flex-col space-y-1 p-2 border-b border-slate-100 mb-1">
					<p className="text-sm font-medium leading-none text-slate-900">{user.fullName || 'User'}</p>
					<p className="text-xs leading-none text-slate-500 truncate">{user.email}</p>
				</div>
				<DropdownMenuItem asChild>
					<Link href="/dashboard/settings/profile" className="cursor-pointer flex items-center gap-2">
						<UserIcon className="h-4 w-4 text-slate-500" />
						<span>Profile Settings</span>
					</Link>
				</DropdownMenuItem>
				<DropdownMenuItem onClick={signOut} className="cursor-pointer text-red-600 focus:text-red-600 flex items-center gap-2">
					<ArrowRightOnRectangleIcon className="h-4 w-4" />
					<span>Sign Out</span>
				</DropdownMenuItem>
			</DropdownMenuContent>
		</DropdownMenu>
	);
}
